
import { Vue, Component, Prop } from "vue-property-decorator";
import AdvertiserAbout from "@/components/revenue/advertiser/AdvertiserAbout.vue";
import AdditionalManagers from "@/components/revenue/advertiser/AdditionalManagers.vue";
import AdvertisersAffiliates from "@/components/revenue/advertiser/AdvertisersAffiliates.vue";
import AdvertiserContractors from "@/components/revenue/advertiser/AdvertiserContractors.vue";
import { Advertiser } from "@/services/advertiser/Advertiser";
import { Getter } from "vuex-class";

@Component({
    components: {
        AdvertiserContractors,
        AdvertisersAffiliates,
        AdditionalManagers,
        AdvertiserAbout,
    },
})

export default class AdvertiserSingle extends Vue {
    @Getter('authModule/GET_USER') getUser;
    @Prop({ required: true }) advertiser!: Advertiser;

    get checkingForAdminAndSupervisor(): boolean {
        const roles = this.getUser.roles;
        return roles.includes('ROLE_SYSTEM')
            || roles.includes('ROLE_ADMIN')
            || roles.includes('ROLE_FINANCE_SUPERVISOR')
            || roles.includes('ROLE_STAT_MANAGER')
            || roles.includes('ROLE_FINANCIER');
    }

    get checkForTheManager(): boolean {
        return this.getUser.roles.includes('ROLE_ACCOUNT_MANAGER') &&
            Array.isArray(this.advertiser.managers) &&
            this.advertiser.managers?.some(el => el.manager_id === this.getUser.account_id);
    }
}
